export default "__VITE_ASSET__BlTpC6sd__"